import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from 'app/services/app.service';
import {SakuraModelService} from 'app/core/sakuraModel.service';
import {plainToInstance} from 'class-transformer';
import {Branch} from 'app/entities/branch.entity';
import {Position} from 'app/entities/position.entity';
import {Worker} from 'app/entities/worker.entity';
import {Pagination} from 'app/entities/pagination.entity';
import {ListModelService} from 'app/core/list.interface';
import {SwitchItem} from '../entities/switch.entity';
import {ApiResponse} from '../entities/apiResponse.entity';
import {SwitchCheckboxCollection} from '../entities/switchCollection.entity';

@Injectable({
  providedIn: 'root'
})
export class WorkersModelService extends SakuraModelService implements ListModelService {

  positions: Position[] = [];
  positionFilters: SwitchCheckboxCollection = null;

  branches: Branch[] = [];
  branchFilters: SwitchCheckboxCollection = null;

  constructor(
    http: HttpClient,
    appService: AppService
  ) {
    super(http, appService);
  }

  getBranches(callback: (branches: Branch[]) => void) {

    this.get({}, 'directory-pwa/filials', (response) => {
      if (response.status) {
        const branchesArray = Object.entries(response.result).map((item) => (
          {
            id: item[0],
            name: item[1]
          }
        ));

        callback(plainToInstance(Branch, branchesArray));
      }
    });

  }

  getPositions(callback: (branches: Position[]) => void) {

    this.get({}, 'directory-pwa/posts', (response) => {
      if (response.status) {
        const branchesArray = Object.entries(response.result).map((item: any) => (
          {...{postCode: item[0]}, ...item[1]}
        ));

        callback(plainToInstance(Position, branchesArray));
      }
    });

  }

  test() {
    this.getRequest({}, () => {

    }, 'https://yii.doxsw.com/index.php?r=api/pwa/worker-list&&page=3&name=');
  }

  getWorkers(
    page = 1,
    searchName: string | null = null,
    positions: string[] | null = null,
    branches: string[] | null = null,
    functionId: string | null = null,
    onShift: string | null = null,
    callback: (workers: Worker[], pagination: Pagination, data: ApiResponse) => void) {

    this.get({
      page,
      name: searchName,
      posts: positions,
      filials: branches,
      function: functionId,
      onShift
    }, 'pwa/worker-list', (response) => {
      if (response) {
        callback(plainToInstance(Worker, response.result?.items) as unknown as Worker[], response.pagination, response);
      }

    });
  }

  getItems(
    page: number = 1,
    filters: any,
    callback: (branches: Worker[], pagination: Pagination, data: ApiResponse) => void
  ) {
    this.getWorkers(page, filters.search, filters.positions, filters.branches, filters.function, filters.onShift, callback);
  }

  loadItemsForFilter() {
    this.positions = [];
    this.positionFilters = null;
    this.branches = [];
    this.branchFilters = null;

    // @todo SAKURA-111 refactor, ideally we must have switches collection entity, that will handle all changes, + factory
    this.getPositions((positions) => {
      this.positions = positions;

      this.positionFilters = new SwitchCheckboxCollection(this.positions.map((item) => item.getSwitchItem()));

    });

    this.getBranches((branches) => {
      this.branches = branches;

      this.branchFilters = new SwitchCheckboxCollection(this.branches.map((item) => item.getSwitchItem()));
    });
  }
}
